import { PrefsPayload, prefsInitialState } from './prefsSlice';
import { RootState } from './store';

export const selectPrefs = (state: RootState): PrefsPayload => ({
	...prefsInitialState,
	...(state.prefs ?? {}),
});
